<div *ngIf='(vm$ | async) as vm'>

    <!-- Header -->
    <div class="pt-3">
        <mdb-card cascade="true" narrower="true" *ngIf="!vm.workingText && !vm.errorText">
            <div class="row">
                <!-- left side -->
                <div class="col-md-8 mr-0">
                    <div class="col-md-8">
                        <div class="view view-cascade overlay gradient-card-header blue-gradient py-2">
                            <h1 class="h1-responsive mb-0">
                                <span>Payroll</span>
                            </h1>
                        </div>
                    </div>
                </div>

                <!-- right side -->
                <div class="col-md-4 mt-1 mb-0">
                    <div class="col-md-12 text-md-right text-center">
                        <div class="row"
                            *ngIf="!showDriverPayrollViewModel && !vmi.reservationFormVm && !vmi.dayFormVm && !vmi.lockFormVm && !vmi.emailFormVm && !vmi.calcFormVm && !vmi.progressFormVm && !vmi.totalFormVm">
                            <div class="col-md-2"
                                *ngIf="vmi.currentPayrollPeriod && vmi.currentPayrollPeriod.payrollPeriodId > 0 && (vmi.currentPayrollPeriod.payrollPeriodLocked || (vmi.currentPayrollPeriod.adjustmentsCommited && !vmi.currentPayrollPeriod.runCalculationSuggestion))">
                                <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect data-mdb-tooltip-init
                                    title="PDF" (click)="createPDFFile()"
                                    [class.disabled]="isReadyToRunPayroll(vmi.currentPayrollPeriod) ? null: true">
                                    <mdb-icon fas icon="file-pdf"></mdb-icon>
                                </a>
                            </div>
                            <div class="col-md-2"
                                *ngIf="vmi.currentPayrollPeriod && vmi.currentPayrollPeriod.payrollPeriodId > 0 && (vmi.currentPayrollPeriod.payrollPeriodLocked || (vmi.currentPayrollPeriod.adjustmentsCommited && !vmi.currentPayrollPeriod.runCalculationSuggestion))">
                                <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect data-mdb-tooltip-init
                                    title="Excel" (click)="createExcelFile()"
                                    [class.disabled]="isReadyToRunPayroll(vmi.currentPayrollPeriod) ? null: true">
                                    <mdb-icon fas icon="file-excel"></mdb-icon>
                                </a>
                            </div>
                            <div class="col-md-2"
                                *ngIf="vmi.currentPayrollPeriod && vmi.currentPayrollPeriod.payrollPeriodId > 0 && !vmi.currentPayrollPeriod.payrollPeriodLocked">
                                <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect
                                    (click)="startCalculateProcess()" data-mdb-tooltip-init title="Calculate Period"
                                    [class.disabled]="isReadyToRunPayroll(vmi.currentPayrollPeriod) ? null: true">
                                    <mdb-icon fas icon="calculator"></mdb-icon>
                                </a>
                            </div>
                            <div class="col-md-2"
                                *ngIf="vmi.currentPayrollPeriod && vmi.currentPayrollPeriod.payrollPeriodId > 0 && !vmi.currentPayrollPeriod.payrollPeriodLocked && vmi.currentPayrollPeriod.adjustmentsCommited && !vmi.currentPayrollPeriod.runCalculationSuggestion">
                                <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect data-mdb-tooltip-init
                                    title="Lock Period" (click)="startLockProcess()"
                                    [class.disabled]="isReadyToRunPayroll(vmi.currentPayrollPeriod) ? null: true">
                                    <mdb-icon fas icon="lock"></mdb-icon>
                                </a>
                            </div>
                            <div class="col-md-2"
                                *ngIf="vmi.currentPayrollPeriod && vmi.currentPayrollPeriod.payrollPeriodId > 0 && vmi.currentPayrollPeriod.isEmailStatementActive
                                        && vmi.currentPayrollPeriod.payrollPeriodLocked && vmi.currentPayrollPeriod.adjustmentsCommited
                                        && vmi.currentPayrollPeriod.statementCreated && vmi.currentPayrollPeriod.statementCreated == vmi.currentPayrollPeriod.totalDriversInPeriod
                                        && (vmi.currentPayrollPeriod.statementEmailed == 0 || vmi.currentPayrollPeriod.statementEmailed != vmi.currentPayrollPeriod.totalDriversInPeriod)">
                                <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect data-mdb-tooltip-init
                                    title="Email Statement" (click)="startEmailProcess()"
                                    [class.disabled]="isReadyToRunPayroll(vmi.currentPayrollPeriod) ? null: true">
                                    <mdb-icon fas icon="envelope"></mdb-icon>
                                </a>
                            </div>
                            <div class="col-md-2">
                                <a *ngIf="!showDriverPayrollViewModel" mdbBtn floating="true" size="sm" gradient="blue"
                                    mdbWavesEffect (click)="goBack()" data-mdb-tooltip-init title="Back">
                                    <mdb-icon fas icon="arrow-left"></mdb-icon>
                                </a>
                            </div>
                        </div>
                        <div class="row" *ngIf="showDriverPayrollViewModel && !vmi.emailFormVm">
                            <div class="col-md-2 offset-md-4"
                                *ngIf="vmi.currentPayrollPeriod.adjustmentsCommited && !vmi.currentPayrollPeriod.runCalculationSuggestion">
                                <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect
                                    (click)="createOnePDFFile()" data-mdb-tooltip-init title="PDF">
                                    <mdb-icon fas icon="file-pdf"></mdb-icon>
                                </a>
                            </div>
                            <div class="col-md-2"
                                *ngIf="vmi.currentPayrollPeriod.adjustmentsCommited && vmi.showDriverEmailButton && vmi.currentPayrollPeriod.isEmailStatementActive && !vmi.currentPayrollPeriod.runCalculationSuggestion">
                                <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect data-mdb-tooltip-init
                                    title="Email Statement" (click)="startemailDriverStatementProcess()">
                                    <mdb-icon fas icon="envelope"></mdb-icon>
                                </a>
                            </div>
                            <div class="col-md-2">
                                <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect data-mdb-tooltip-init
                                    title="Exit" (click)="exitPayrollView()">
                                    <mdb-icon fas icon="arrow-left"></mdb-icon>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <mdb-card-body cascade="true" class="py-2">
            </mdb-card-body>
        </mdb-card>

        <app-page-loader [vm]="vm"></app-page-loader>
    </div>
    <!-- End Header -->

    <div *ngIf="vm.workingText">
        <span>{{vm.workingText}}</span>
    </div>
    <div *ngIf="vm.errorText">
        <h1 class="text-danger">{{vm.errorText}}</h1>
    </div>

    <!-- toolbar -->
    <div
        *ngIf="!vm.workingText && !vm.errorText && !showDriverPayrollViewModel && !vmi.reservationFormVm && !vmi.dayFormVm && !vmi.lockFormVm && !vmi.emailFormVm && !vmi.calcFormVm && !vmi.progressFormVm && !vmi.totalFormVm">
        <mdb-card cascade="true" narrower="true" class="my-3">
            <mdb-card-body>
                <div class="row mt-n4 mb-n4">
                    <div class="col-md-5">
                        <div class="mx-2">
                            <div class="md-form form-group form-sm">
                                <mdb-select-2 placeholder="Choose the payroll period"
                                    (selected)="getSelectedValue($event, vm.payrollPeriodsVm)"
                                    [(ngModel)]="currentPayrollPeriod">
                                    <mdb-select-option *ngFor="let pp of vm.payrollPeriodsVm.rows; let i = index"
                                        [value]="pp.payrollPeriodId">
                                        <div class="row">
                                            <div class="col-md-2">
                                                {{pp.startDate | date: 'MM/dd/yyyy'}}
                                            </div>
                                            <div class="col-md-2">
                                                {{pp.endDate | date: 'MM/dd/yyyy'}}
                                            </div>
                                            <div class="col-md-3 text-center">
                                                {{pp.payrollLocation}}
                                            </div>
                                            <div class="col-md-1">
                                                <mdb-icon *ngIf="pp.payrollPeriodLocked" fas icon="lock" class="prefix"
                                                    data-mdb-tooltip-init title="Period Locked">
                                                </mdb-icon>
                                                <mdb-icon *ngIf="!pp.payrollPeriodLocked" style="color:green;" fas
                                                    icon="lock-open" class="prefix" data-mdb-tooltip-init
                                                    title="Period Open"></mdb-icon>
                                            </div>
                                            <div class="col-md-1">
                                                <mdb-icon
                                                    *ngIf="pp.statementCreated && pp.statementCreated > 0 && pp.statementCreated != pp.totalDriversInPeriod"
                                                    style="color:red;" fas icon="file-alt" data-mdb-tooltip-init
                                                    title="Statements Save Error" class="prefix"></mdb-icon>
                                                <mdb-icon
                                                    *ngIf="pp.statementCreated && pp.statementCreated > 0 && pp.statementCreated == pp.totalDriversInPeriod"
                                                    style="color:black;" fas icon="file-alt" class="prefix"
                                                    data-mdb-tooltip-init title="Statements Saved"></mdb-icon>
                                                <mdb-icon *ngIf="!pp.statementCreated || pp.statementCreated == 0"
                                                    style="color:green;" fas icon="file-alt" data-mdb-tooltip-init
                                                    title="No Statements Saved" class="prefix"></mdb-icon>
                                            </div>
                                            <div class="col-md-1">
                                                <mdb-icon
                                                    *ngIf="pp.statementEmailed && pp.statementEmailed > 0  && pp.statementEmailed != pp.totalDriversInPeriod"
                                                    style="color:red;" fas icon="envelope-open" data-mdb-tooltip-init
                                                    title="Statements Email Error" class="prefix"></mdb-icon>
                                                <mdb-icon
                                                    *ngIf="pp.statementEmailed && pp.statementEmailed > 0 && pp.statementEmailed == pp.totalDriversInPeriod"
                                                    style="color:black;" fas icon="envelope" class="prefix"
                                                    data-mdb-tooltip-init title="Statements Emailed"></mdb-icon>
                                                <mdb-icon *ngIf="!pp.statementEmailed || pp.statementEmailed == 0"
                                                    style="color:green;" fas icon="envelope-open" data-mdb-tooltip-init
                                                    title="No Statements Emailed" class="prefix"></mdb-icon>
                                            </div>
                                            <div class="col-md-1">
                                                <mdb-icon style="color:red;" *ngIf="pp.queueStatus == 3" fas
                                                    icon="exclamation-circle" class="prefix" data-mdb-tooltip-init
                                                    title="Error" placement="setPopoverPlacement(i);"></mdb-icon>
                                                <mdb-icon style="color:green;" *ngIf="pp.queueStatus == 2" fas
                                                    icon="check-circle" class="prefix" data-mdb-tooltip-init
                                                    title="Success" placement="setPopoverPlacement(i);"></mdb-icon>
                                                <mdb-icon style="color:blue;" *ngIf="pp.queueStatus < 2" fas
                                                    icon="times-circle" class="prefix" data-mdb-tooltip-init
                                                    title="In Process" placement="setPopoverPlacement(i);"></mdb-icon>
                                            </div>
                                            <div class="col-md-1">
                                                <mdb-icon style="color:red;" *ngIf="!pp.adjustmentsCommited || pp.runCalculationSuggestion" fas
                                                    icon="calculator" class="prefix" data-mdb-tooltip-init
                                                    title="Need Run Calculations"
                                                    placement="setPopoverPlacement(i);"></mdb-icon>
                                            </div>
                                        </div>
                                    </mdb-select-option>
                                </mdb-select-2>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="mx-2 my-3" style="text-align:center;">
                            <div class="row">
                                <div class="col-md-2">
                                    <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect
                                        (click)="refreshPage()" data-mdb-tooltip-init title="Refresh">
                                        <mdb-icon fas icon="redo-alt"></mdb-icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="mx-2">
                            <div class="md-form form-group form-sm">
                                <mdb-checkbox *ngIf="vmi.currentPayrollPeriod.payrollPeriodId"
                                    [(ngModel)]="vmi.sortByDriverName">Sort By Driver Name
                                </mdb-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mx-2">
                            <div class="md-form form-group form-sm" *ngIf="vmi.currentPayrollPeriod.payrollPeriodId">
                                <input mdbInput [mdbDatepicker]="datepicker" type="date" class="form-control"
                                    id="payrollCheckDate" [(ngModel)]="vmi.currentPayrollPeriod.payrollCheckDate" />
                                <label mdbLabel for="payrollCheckDate" class="form-label">Check Date</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2 mb-n1"
                    *ngIf="vmi.currentPayrollPeriod && vmi.currentPayrollPeriod.payrollPeriodId > 0">
                    <div class="col-md-3" *ngIf="!vmi.currentPayrollPeriod.adjustmentsCommited">
                        <span class="badge badge-danger">The changes not included in the totals</span>
                    </div>
                    <div class="col-md-3"
                        *ngIf="vmi.currentPayrollPeriod.adjustmentsCommited && !vmi.currentPayrollPeriod.runCalculationSuggestion">
                        <span class="badge badge-success">The changes are included in the totals</span>
                    </div>
                    <div class="col-md-3"
                        *ngIf="vmi.currentPayrollPeriod.adjustmentsCommited && vmi.currentPayrollPeriod.runCalculationSuggestion">
                        <span class="badge badge-danger">Please run calculation</span>
                    </div>
                    <div class="col-md-3" *ngIf="!vmi.currentPayrollPeriod.payrollPeriodLocked">
                        <span class="badge badge-danger">Payroll Period Not Locked</span>
                    </div>
                    <div class="col-md-3 text-success" *ngIf="vmi.currentPayrollPeriod.payrollPeriodLocked">
                        <ng-container
                            *ngIf="vmi.currentPayrollPeriod.lockedByUserName && vmi.currentPayrollPeriod.lockedDateTime">
                            <span class="badge badge-success">Payroll Locked by
                                {{vmi.currentPayrollPeriod.lockedByUserName}} on
                                {{vmi.currentPayrollPeriod.lockedDateTime | date:
                                'MM'}}/{{vmi.currentPayrollPeriod.lockedDateTime |
                                date:'dd'}}/{{vmi.currentPayrollPeriod.lockedDateTime | date: 'yyyy'}}</span>
                        </ng-container>
                        <ng-container
                            *ngIf="!vmi.currentPayrollPeriod.lockedByUserName || !vmi.currentPayrollPeriod.lockedDateTime">
                            <span class="badge badge-success">Payroll Locked</span>
                        </ng-container>
                    </div>
                    <div class="col-md-3"
                        *ngIf="vmi.currentPayrollPeriod.totalDriversInPeriod && vmi.currentPayrollPeriod.statementCreated && vmi.currentPayrollPeriod.payrollPeriodLocked && vmi.currentPayrollPeriod.statementCreated != vmi.currentPayrollPeriod.totalDriversInPeriod">
                        <span class="badge badge-danger">{{vmi.currentPayrollPeriod.statementCreated}} out
                            {{vmi.currentPayrollPeriod.totalDriversInPeriod}} Statements Created</span>
                    </div>
                    <div class="col-md-3"
                        *ngIf="vmi.currentPayrollPeriod.totalDriversInPeriod && vmi.currentPayrollPeriod.statementCreated && vmi.currentPayrollPeriod.payrollPeriodLocked && vmi.currentPayrollPeriod.statementCreated === vmi.currentPayrollPeriod.totalDriversInPeriod">
                        <span class="badge badge-success">{{vmi.currentPayrollPeriod.statementCreated}} out
                            {{vmi.currentPayrollPeriod.totalDriversInPeriod}} Statements Created</span>
                    </div>
                    <div class="col-md-3"
                        *ngIf="vmi.currentPayrollPeriod.totalDriversInPeriod && vmi.currentPayrollPeriod.statementEmailed && vmi.currentPayrollPeriod.payrollPeriodLocked && vmi.currentPayrollPeriod.statementEmailed != vmi.currentPayrollPeriod.totalDriversInPeriod">
                        <span class="badge badge-danger">{{vmi.currentPayrollPeriod.statementEmailed}} out
                            {{vmi.currentPayrollPeriod.totalDriversInPeriod}} Statements Emailed</span>
                    </div>
                    <div class="col-md-3"
                        *ngIf="vmi.currentPayrollPeriod.totalDriversInPeriod && vmi.currentPayrollPeriod.statementEmailed && vmi.currentPayrollPeriod.payrollPeriodLocked && vmi.currentPayrollPeriod.statementEmailed === vmi.currentPayrollPeriod.totalDriversInPeriod">
                        <span class="badge badge-success">{{vmi.currentPayrollPeriod.statementEmailed}} out
                            {{vmi.currentPayrollPeriod.totalDriversInPeriod}} Statements Emailed</span>
                    </div>
                    <div class="col-md-3"
                        *ngIf="vmi.currentPayrollPeriod.totalDriversInPeriod && vmi.currentPayrollPeriod.isEmailStatementActive && vmi.currentPayrollPeriod.payrollPeriodLocked && vmi.currentPayrollPeriod.statementEmailed === 0">
                        <span class="badge badge-danger">Statements NOT Emailed</span>
                    </div>
                </div>
                <div class="row mt-2 mb-n1" *ngIf="vmi.messageString != undefined && vmi.messageString.length > 0">
                    <div class="col-md-12 text-center text-danger">
                        <strong>{{vmi.messageString}}</strong>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>

    <div *ngIf="vmi.actionErrorMessage">
        <div class="row mt-2 mb-2 mb-2">
            <div class="col-md-12 text-center text-danger">
                <strong>{{vmi.actionErrorMessage}}</strong>
            </div>
        </div>
    </div>
    <div *ngIf="vmi.actionMessage">
        <div class="row mt-2 mb-2 mb-2">
            <div class="col-md-12 text-center text-info">
                <strong>{{vmi.actionMessage}}</strong>
            </div>
        </div>
    </div>

    <!-- Lock Screen Confirmation/Progress-->
    <div *ngIf="vmi.lockFormVm as lvm" class="my-6">
        <div class="row">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <mdb-card-body cascade="true">
                        <div class="text-center text-info">
                            <strong>Are you sure you want to lock
                                {{vmi.currentPayrollPeriod.startDate | date: 'MM'}}/{{vmi.currentPayrollPeriod.startDate
                                | date: 'dd'}}/{{vmi.currentPayrollPeriod.startDate | date: 'yyyy'}} -
                                {{vmi.currentPayrollPeriod.endDate | date: 'MM'}}/{{vmi.currentPayrollPeriod.endDate |
                                date: 'dd'}}/{{vmi.currentPayrollPeriod.endDate | date: 'yyyy'}}
                                {{vmi.currentPayrollPeriod.payrollLocation}}
                                pay
                                period?</strong>
                        </div>
                        <br />
                        <div class="row d-flex justify-content-center">
                            <app-form-ok-cancel [vm]="lvm.okCancelVm" (cancelClicked)="lockFormCanceled()"
                                (okClicked)="lockFormOk()">
                            </app-form-ok-cancel>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <!-- Email Statement Screen Confirmation/Progress-->
    <div *ngIf="vmi.emailFormVm as evm" class="my-6">
        <div class="row">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <mdb-card-body cascade="true">
                        <div *ngIf="evm.viewType == 'statement'">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-input [vm]="evm.emailAddressVm1"
                                                (textChanged)="emailFormValidate(evm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-input [vm]="evm.emailAddressVm2"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div class="row d-flex justify-content-center">
                                <app-form-ok-cancel [vm]="evm.okCancelVm" (cancelClicked)="emailDriverFormCanceled()"
                                    (okClicked)="emailDriverFormOk(evm)" [isInvalid]="!evm.isValid">
                                </app-form-ok-cancel>
                            </div>
                        </div>
                        <div *ngIf="evm.viewType == 'all-statements'">
                            <div class="text-center text-info">
                                <strong>Are you sure you want to send statements
                                    {{vmi.currentPayrollPeriod.startDate | date:
                                    'MM'}}/{{vmi.currentPayrollPeriod.startDate
                                    | date: 'dd'}}/{{vmi.currentPayrollPeriod.startDate | date: 'yyyy'}} -
                                    {{vmi.currentPayrollPeriod.endDate | date: 'MM'}}/{{vmi.currentPayrollPeriod.endDate
                                    |
                                    date: 'dd'}}/{{vmi.currentPayrollPeriod.endDate | date: 'yyyy'}}
                                    {{vmi.currentPayrollPeriod.payrollLocation}}
                                    pay
                                    period?</strong>
                            </div>
                            <br />
                            <div class="row d-flex justify-content-center">
                                <app-form-ok-cancel [vm]="evm.okCancelVm" (cancelClicked)="emailFormCanceled()"
                                    (okClicked)="emailFormOk()">
                                </app-form-ok-cancel>
                            </div>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <!-- Calculation Confirmation/Progress-->
    <div *ngIf="vmi.calcFormVm as cvm" class="my-6">
        <div class="row">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <mdb-card-body cascade="true">
                        <div class="text-center text-info">
                            <strong>Start calculation for
                                {{vmi.currentPayrollPeriod.startDate | date: 'MM'}}/{{vmi.currentPayrollPeriod.startDate
                                | date: 'dd'}}/{{vmi.currentPayrollPeriod.startDate | date: 'yyyy'}} -
                                {{vmi.currentPayrollPeriod.endDate | date: 'MM'}}/{{vmi.currentPayrollPeriod.endDate |
                                date: 'dd'}}/{{vmi.currentPayrollPeriod.endDate | date: 'yyyy'}}
                                {{vmi.currentPayrollPeriod.payrollLocation}}
                                pay
                                period?</strong>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-5">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="cvm.emailAddressVm"
                                            (textChanged)="calculateFormValidate(vm, cvm)"></app-form-input>
                                        <div class="note note-primary text-secondary ml-2 my-n4">
                                            Please enter your email address for notification that payroll calculation
                                            has been completed.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="row d-flex justify-content-center">
                            <app-form-ok-cancel [vm]="cvm.okCancelVm" (cancelClicked)="calculateFormCanceled()"
                                [isInvalid]="!cvm.isValid" (okClicked)="calculateFormOk(cvm)">
                            </app-form-ok-cancel>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <!-- Progress Window -->
    <div *ngIf="vmi.progressFormVm as pvm" class="my-6">
        <div class="row">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <mdb-card-body cascade="true">
                        <div *ngIf="pvm.errorText === undefined || pvm.errorText.length === 0">
                            <strong><mdb-badge color="red">PLEASE WAIT UNTIL COMPLETED</mdb-badge></strong>
                        </div>
                        <div class="text-center text-info" *ngIf="pvm.message != undefined && pvm.message.length > 0">
                            <strong>{{pvm.message}}</strong>
                        </div>
                        <div class="text-center text-danger"
                            *ngIf="pvm.errorText != undefined && pvm.errorText.length > 0">
                            <strong>{{pvm.errorText}}</strong>
                            <br />
                            <div class="offset-md-4 col-md-4" *ngIf="pvm.dataList && pvm.dataList.length > 0">
                                <table responsive="true" class="table table-borderless table-sm">
                                    <tbody>
                                        <tr class="h6" *ngFor="let dl of pvm.dataList">
                                            <td class="text-left">
                                                {{dl.column1}}
                                            </td>
                                            <td class="text-left">
                                                {{dl.column2}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div class="row d-flex justify-content-center"
                            *ngIf="pvm.errorText === undefined || pvm.errorText.length === 0">
                            <br />
                            <div class="col-md-6" *ngIf="pvm.valueNow != undefined">
                                <mdb-progress class="bg-info" value="{{pvm.valueNow}}" min="0" max="100"
                                    aria-valuenow="{{pvm.valueNow}}" aria-valuemin="0"
                                    aria-valuemax="100"></mdb-progress>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center"
                            *ngIf="pvm.errorText != undefined && pvm.errorText.length > 0">
                            <button style="margin-top:-5px; width: 150px;" mdbBtn type="button" color="info"
                                rounded="true" outline="true" size="sm" mdbWavesEffect class="btn-block"
                                (click)="progressFormVmClose()">
                                Close
                            </button>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <!-- Reservation changes input screen -->
    <div *ngIf="vmi.reservationFormVm as rvm">
        <div class="row">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <mdb-card-body cascade="true">
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-3">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="rvm.confirmationNumberVm"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="rvm.parkingAmountVm"
                                            (textChanged)="resFormValidate(rvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="rvm.tollAmountVm"
                                            (textChanged)="resFormValidate(rvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n2 mb-4">
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                            <div class="col-md-2 text-center" style="color: brown;">Additional Pay Amounts</div>
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="rvm.miscAmountVm1"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="rvm.miscReasonVm1" [optionValue]="rvm.data.miscReason1"
                                            (selectChanged)="resReasonChanged($event, 1, rvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="rvm.showOtherReason1">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="rvm.otherReasonVm1"
                                            (textChanged)="resFormValidate(rvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="rvm.miscAmountVm2"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="rvm.miscReasonVm2" [optionValue]="rvm.data.miscReason2"
                                            (selectChanged)="resReasonChanged($event, 2, rvm, vmd)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="rvm.showOtherReason2">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="rvm.otherReasonVm2"
                                            (textChanged)="resFormValidate(rvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="rvm.miscAmountVm3"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="rvm.miscReasonVm3" [optionValue]="rvm.data.miscReason3"
                                            (selectChanged)="resReasonChanged($event, 3, rvm, vmd)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="rvm.showOtherReason3">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="rvm.otherReasonVm3"
                                            (textChanged)="resFormValidate(rvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n2 mb-4" *ngIf="rvm.allowMoveTrip">
                            <div class="col-md-4">
                                <hr class="hr" />
                            </div>
                            <div class="col-md-4 text-center" style="color: brown;">Move Trip to Different Day (for
                                overnight trip issue)</div>
                            <div class="col-md-4">
                                <hr class="hr" />
                            </div>
                        </div>
                        <div class="row mt-n2 mb-4" *ngIf="rvm.allowMoveTrip">
                            <div class="col-md-4"></div>
                            <div class="col-md-4 text-center">
                                <mdb-checkbox [(ngModel)]="rvm.moveDateChecked" (change)="moveDateChanged(rvm)">
                                    <span class="text-muted fw-normal" style="font-size: 0.95rem;">
                                        Move Trip to {{ rvm.dateTimeToMove | date: 'MM/dd/yyyy' }}
                                    </span>
                                </mdb-checkbox>
                            </div>
                            <div class="col-md-4"></div>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <app-form-ok-cancel [vm]="rvm.okCancelVm" (cancelClicked)="updatePayrollReservationCancel()"
                                (okClicked)="reservationFormOk(rvm)" [isInvalid]="!rvm.isValid">
                            </app-form-ok-cancel>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <!-- day change inpit screen -->
    <div *ngIf="vmi.dayFormVm as dvm">
        <div class="row">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <mdb-card-body cascade="true">
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.driverNumberVm"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.payrollDateVm"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4 mb-4">
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                            <div class="col-md-2 text-center" style="color: brown;">Additional Time</div>
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.additionalMinutesVm1"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="dvm.additionalMinutesReasonVm1"
                                            [optionValue]="dvm.data.additionalMinutesReason1"
                                            (selectChanged)="dayReasonChanged($event, 1, dvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="dvm.showMinOtherReason1">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.otherMinReasonVm1"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.additionalMinutesVm2"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="dvm.additionalMinutesReasonVm2"
                                            [optionValue]="dvm.data.additionalMinutesReason2"
                                            (selectChanged)="dayReasonChanged($event, 2, dvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="dvm.showMinOtherReason2">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.otherMinReasonVm2"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.additionalMinutesVm3"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="dvm.additionalMinutesReasonVm3"
                                            [optionValue]="dvm.data.additionalMinutesReason3"
                                            (selectChanged)="dayReasonChanged($event, 3, dvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="dvm.showMinOtherReason3">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.otherMinReasonVm3"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4 mb-4">
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                            <div class="col-md-2 text-center" style="color: brown;">Additional Pay Amounts</div>
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.miscAmountVm1"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="dvm.miscReasonVm1" [optionValue]="dvm.data.miscReason1"
                                            (selectChanged)="dayReasonChanged($event, 1, dvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="dvm.showOtherReason1">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.otherReasonVm1"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.miscAmountVm2"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="dvm.miscReasonVm2" [optionValue]="dvm.data.miscReason2"
                                            (selectChanged)="dayReasonChanged($event, 2, dvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="dvm.showOtherReason2">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.otherReasonVm2"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.miscAmountVm3"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="dvm.miscReasonVm3" [optionValue]="dvm.data.miscReason3"
                                            (selectChanged)="dayReasonChanged($event, 3, dvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="dvm.showOtherReason3">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.otherReasonVm3"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4 mb-4">
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                            <div class="col-md-2 text-center" style="color: brown;">Shift Breaks</div>
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-4">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.breakDateInputVm1"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.breakStartInputVm1"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.breakEndInputVm1"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-4">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.breakDateInputVm2"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.breakStartInputVm2"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="dvm.breakEndInputVm2"
                                            (textChanged)="dayFormValidate(dvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <app-form-ok-cancel [vm]="dvm.okCancelVm" (cancelClicked)="updatePayrollDayCancel()"
                                (okClicked)="dayFormOk(dvm)" [isInvalid]="!dvm.isValid">
                            </app-form-ok-cancel>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <!-- total change inpit screen -->
    <div *ngIf="vmi.totalFormVm as tvm">
        <div class="row">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <mdb-card-body cascade="true">
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="tvm.driverNumberVm"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4 mb-4">
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                            <div class="col-md-2 text-center" style="color: brown;">Additional Pay Amounts</div>
                            <div class="col-md-5">
                                <hr class="hr" />
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="tvm.miscAmountVm1"
                                            (textChanged)="totalFormValidate(tvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="tvm.miscReasonVm1" [optionValue]="tvm.data.miscReason1"
                                            (selectChanged)="totalReasonChanged($event, 1, tvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="tvm.showOtherReason1">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="tvm.otherReasonVm1"
                                            (textChanged)="totalFormValidate(tvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="tvm.miscAmountVm2"
                                            (textChanged)="totalFormValidate(tvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="tvm.miscReasonVm2" [optionValue]="tvm.data.miscReason2"
                                            (selectChanged)="totalReasonChanged($event, 2, tvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="tvm.showOtherReason2">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="tvm.otherReasonVm2"
                                            (textChanged)="totalFormValidate(tvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="tvm.miscAmountVm3"
                                            (textChanged)="totalFormValidate(tvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="tvm.miscReasonVm3" [optionValue]="tvm.data.miscReason3"
                                            (selectChanged)="totalReasonChanged($event, 3, tvm)"></app-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4 mb-n4" *ngIf="tvm.showOtherReason3">
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mx-2">
                                    <div class="md-form form-group form-sm">
                                        <app-form-input [vm]="tvm.otherReasonVm3"
                                            (textChanged)="totalFormValidate(tvm)"></app-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <app-form-ok-cancel [vm]="tvm.okCancelVm" (cancelClicked)="updatePayrollTotalCancel()"
                                (okClicked)="totalFormOk(tvm)" [isInvalid]="!tvm.isValid">
                            </app-form-ok-cancel>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <!-- payroll view -->
    <div *ngIf='(vmv$ | async) as vmv'>
        <div *ngIf="showPayrollViewModel">
            <!-- working -->
            <div class="row" *ngIf="vmv.workingText">
                <div class="col-md-12">
                    <div class="text-center">
                        <div>{{vmv.workingText}}</div>
                        <mdb-spinner spinnerColor="blue"></mdb-spinner>
                    </div>
                </div>
            </div>
            <!-- error -->
            <div class="row" *ngIf="vmv.errorText">
                <div class="col-md-12">
                    <div class="text-center text-danger">
                        <div>{{vmv.errorText}}</div>
                    </div>
                </div>
            </div>
            <div class="row mt-0" *ngIf="!vmv.workingText && !vmv.errorText">
                <!-- left side -->
                <div class="col-md-4 mb-0">
                    <!-- Search form -->
                    <div class="form-inline md-form form-sm my-0">
                        <mdb-icon fas icon="search" aria-hidden="true"></mdb-icon>
                        <input class="form-control form-control-sm ml-5 w-75" type="search" [ngModel]="searchData"
                            (ngModelChange)="doDataSearch(vmv, $event)" placeholder="Search text">
                    </div>
                </div>
                <div class="col-md-2 mt-n4">
                    <div class="md-form form-group form-sm">
                        <mdb-checkbox [(ngModel)]="statementsNotCreated"
                            (change)="statementsNotCreatedChanged(vmv, $event)">Statements Not Created
                        </mdb-checkbox>
                    </div>
                </div>
                <div class="col-md-2 mt-n4">
                    <div class="md-form form-group form-sm">
                        <mdb-checkbox [(ngModel)]="statementsWithErrors"
                            (change)="statementsCreatedErrorChanged(vmv, $event)">Statements With Errors
                        </mdb-checkbox>
                    </div>
                </div>
                <div class="col-md-2 mt-n4">
                    <div class="md-form form-group form-sm">
                        <mdb-checkbox [(ngModel)]="statementsNotEmailed"
                            (change)="statementsNotEmailedChanged(vmv, $event)">Statements Not Emailed
                        </mdb-checkbox>
                    </div>
                </div>
                <div class="col-md-2 mt-n4">
                    <div class="md-form form-group form-sm">
                        <mdb-checkbox [(ngModel)]="statementsEmailedWithError"
                            (change)="statementsEmailedErrorChanged(vmv, $event)">Email Statements Errors
                        </mdb-checkbox>
                    </div>
                </div>
            </div>
            <div class="row mt-0" *ngIf="!vmv.workingText && !vmv.errorText && vmi.warningCount > 0">
                <div class="col-md-2 mt-4"></div>
                <div class="col-md-4 mt-3">
                    <div class="form-inline md-form form-sm my-0 float-right">
                        <span class="badge badge-danger" style="font-size: 16px !important;">We found
                            {{vmi.warningCount}} warnings. Please review them before process.</span>
                    </div>
                </div>
                <div class="col-md-3 mt-n4 text-left">
                    <div class="md-form form-group form-sm float-left">
                        <mdb-checkbox [(ngModel)]="chauffeursWithWarnings"
                            (change)="filterChauffeursWithWarnings(vmv, $event)">Show chauffeurs with warnings
                        </mdb-checkbox>
                    </div>
                </div>
            </div>
            <div class="row mt-0"
                *ngIf="!vmv.workingText && !vmv.errorText && (vmi.notSignedTimeSheetsCount > 0 || vmi.timeSheetsIssueCount > 0 || vmi.isReviewNotCompletedCount > 0)">
                <div class="col-md-2 mt-4"></div>
                <div class="col-md-3 mt-n4 text-left" *ngIf="vmi.notSignedTimeSheetsCount > 0">
                    <div class="md-form form-group form-sm float-left">
                        <mdb-checkbox [(ngModel)]="chauffeursWithNotSignedTimesheet"
                            (change)="filterChauffeursWithNotSignedTimesheet(vmv, $event)"><span
                                class="text-danger fw-bold">{{vmi.notSignedTimeSheetsCount}} Timesheets Not
                                Signed</span>
                        </mdb-checkbox>
                    </div>
                </div>
                <div class="col-md-3 mt-n4 text-left" *ngIf="vmi.timeSheetsIssueCount > 0">
                    <div class="md-form form-group form-sm float-left">
                        <mdb-checkbox [(ngModel)]="timeSheetsWithIssue"
                            (change)="filterTimesheetsWithIssue(vmv, $event)"><span
                                class="text-danger fw-bold">{{vmi.timeSheetsIssueCount}} Timesheets With Issues</span>
                        </mdb-checkbox>
                    </div>
                </div>
                <div class="col-md-3 mt-n4 text-left" *ngIf="vmi.isReviewNotCompletedCount > 0 && vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX'">
                    <div class="md-form form-group form-sm float-left">
                        <mdb-checkbox [(ngModel)]="chauffeursReviewNotCompleted"
                            (change)="filterIsReviewNotCompletedCount(vmv, $event)"><span
                                class="text-danger fw-bold">{{vmi.isReviewNotCompletedCount}} Chauffeurs Not
                                Reviewed</span>
                        </mdb-checkbox>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!vmv.workingText && !vmv.errorText">
                <div class="col-md-3 mt-3" *ngFor="let d of vmv.payrollDisplayDataFilteredVm">
                    <div (click)="showDriverPayroll(d)">
                        <mdb-card narrower="true" cascade="true" class="div_hover">
                            <app-card-header title="{{d.driverCode}}" headerClass="{{setCardHeaderColor(d)}}"
                                [headingSize]="6"></app-card-header>
                            <mdb-card-body cascade="true">
                                <div>
                                    <div class="row small mb-2">
                                        <div class="col-md-5"><strong>{{d.driverName}}</strong></div>
                                        <div class="col-md-1"
                                            *ngIf="d.isReviewCompleted && d.isReviewCompleted === true && vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX'">
                                            <mdb-icon style="color:green;" fas icon="check" class="prefix" size="lg"
                                                data-mdb-tooltip-init title="Payroll Reviewed and Corrected"></mdb-icon>
                                        </div>
                                        <div class="col-md-1"
                                            *ngIf="(!d.isReviewCompleted || d.isReviewCompleted === false) && vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX'">
                                            <mdb-icon style="color:red;" fas icon="check" class="prefix" size="lg"
                                                data-mdb-tooltip-init title="Chauffeur Not Reviewed"></mdb-icon>
                                        </div>
                                        <div class="col-md-1">
                                            <mdb-icon *ngIf="d.statementStatus && d.statementStatus === 3"
                                                style="color:red;" fas icon="file-alt" class="prefix" size="lg"
                                                data-mdb-tooltip-init title="{{d.statementError}}"></mdb-icon>
                                            <mdb-icon *ngIf="d.statementStatus && d.statementStatus === 2" size="2x"
                                                style="color:black;" fas icon="file-alt" class="prefix" size="lg"
                                                data-mdb-tooltip-init title="Statements Saved"></mdb-icon>
                                            <mdb-icon *ngIf="!d.statementStatus || d.statementStatus === 0"
                                                style="color:green;" fas icon="file-alt" class="prefix" size="lg"
                                                data-mdb-tooltip-init title="No Statements Saved"></mdb-icon>
                                        </div>
                                        <div class="col-md-1">
                                            <mdb-icon *ngIf="d.statementEmailStatus && d.statementEmailStatus === 3"
                                                style="color:red;" fas icon="envelope-open" class="prefix" size="lg"
                                                data-mdb-tooltip-init title="{{d.statementEmailError}}"></mdb-icon>
                                            <mdb-icon *ngIf="d.statementEmailStatus && d.statementEmailStatus === 2"
                                                style="color:black;" fas icon="envelope" class="prefix" size="lg"
                                                data-mdb-tooltip-init title="Statements Emailed"></mdb-icon>
                                            <mdb-icon *ngIf="!d.statementEmailStatus || d.statementEmailStatus === 0"
                                                style="color:green;" fas icon="envelope-open" class="prefix" size="lg"
                                                data-mdb-tooltip-init title="No Statements Emailed"></mdb-icon>
                                        </div>
                                        <div class="col-md-1"
                                            *ngIf="d.notSignedTimeSheetsCount && d.notSignedTimeSheetsCount > 0">
                                            <mdb-icon style="color:red;" fas icon="file-signature" class="prefix"
                                                size="lg" data-mdb-tooltip-init
                                                title="Timesheets Not Signed"></mdb-icon>
                                        </div>
                                        <div class="col-md-1"
                                            *ngIf="d.notSignedTimeSheetsCount && d.notSignedTimeSheetsCount === 0">
                                            <mdb-icon style="color:green;" fas icon="file-signature" class="prefix"
                                                size="lg" data-mdb-tooltip-init title="Signed Timesheets"></mdb-icon>
                                        </div>
                                        <div class="col-md-1" *ngIf="!d.notSignedTimeSheetsCount">
                                        </div>
                                        <div class="col-md-1"
                                            *ngIf="d.timeSheetsIssueCount && d.timeSheetsIssueCount > 0">
                                            <mdb-icon style="color:red;" fas icon="exclamation-triangle" class="prefix"
                                                size="lg" data-mdb-tooltip-init title="Timesheet Issues"></mdb-icon>
                                        </div>
                                        <div class="col-md-1"
                                            *ngIf="d.timeSheetsIssueCount && d.timeSheetsIssueCount === 0">
                                            <mdb-icon style="color:green;" fas icon="exclamation-triangle"
                                                class="prefix" size="lg" data-mdb-tooltip-init
                                                title="Signed Timesheets"></mdb-icon>
                                        </div>
                                        <div class="col-md-1" *ngIf="d.warningCount && d.warningCount > 0">
                                            <mdb-icon style="color:red;" fas icon="exclamation-circle" class="prefix"
                                                size="lg" data-mdb-tooltip-init
                                                title="Hours Adjustments Warning"></mdb-icon>
                                        </div>
                                    </div>
                                    <div class="row small">
                                        <div class="col-md-4">Trips:</div>
                                        <div class="col-md-2"><strong>{{d.numberOfTrips}}</strong></div>
                                        <div class="col-md-4">StandBy:</div>
                                        <div class="col-md-2"><strong>{{d.numberOfStandBy}}</strong></div>
                                    </div>
                                    <div class="row small">
                                        <div class="col-md-4">Days:</div>
                                        <div class="col-md-2"><strong>{{d.numberOfWorkingDays}}</strong></div>
                                        <div class="col-md-4">Hours:</div>
                                        <div class="col-md-2"><strong>{{d.totalDayMinutes | minToTime}}</strong></div>
                                    </div>
                                    <div class="row small">
                                        <div class="col-md-4">Adjustments:</div>
                                        <div class="col-md-2"><strong>{{d.numberOfAdjustments}}</strong></div>
                                        <div class="col-md-4">{{ vmi.currentPayrollPeriod?.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX' ? 'Priced' : '' }}</div>
                                        <div class="col-md-2"><strong>{{ vmi.currentPayrollPeriod?.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX' ? d.pricedTripsCount : '' }}</strong></div>
                                    </div>
                                    <div class="row small">
                                        <div class="col-md-4">Users Adjusted:</div>
                                        <div class="col-md-2"><strong>{{d.editUsers}}</strong></div>
                                        <div class="col-md-4">{{ vmi.currentPayrollPeriod?.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX' ? 'Not Priced' : '' }}</div>
                                        <div class="col-md-2"><strong
                                                [ngClass]="{ 'text-danger': d.notPricedCount > 0 }">{{ vmi.currentPayrollPeriod?.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX' ? d.notPricedCount : '' }}
                                            </strong>
                                        </div>
                                    </div>
                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- view driver payroll -->
<div *ngIf='(vmd$ | async) as vmd'>
    <div *ngIf="showDriverPayrollViewModel">
        <!-- working -->
        <div class="row" *ngIf="vmd.workingText">
            <div>
                <div class="text-center">
                    <div>{{vmd.workingText}}</div>
                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </div>
            </div>
        </div>
        <!-- error -->
        <div class="row" *ngIf="vmd.errorText">
            <div class="col-md-12">
                <div class="text-center text-danger">
                    <div>{{vmd.errorText}}</div>
                </div>
            </div>
        </div>
        <div class="row mt-0" *ngIf="!vmd.workingText && !vmd.errorText">

            <!-- Payroll compare section -->
            <div class="col-md-12 mb-0 mt-3" *ngIf="vmd.driverPayrollCompareDataVm">
                <app-payroll-compare-card [vm]="vmd.driverPayrollCompareDataVm">
                </app-payroll-compare-card>
            </div>
            <div class="col-md-12 mb-0 mt-3">
                <mdb-card narrower="true" cascade="true">
                    <app-card-header title="{{buildDriverPayrollHeader(vmd.driverPayrollDataFilteredVm)}}"
                        [headingSize]="6"></app-card-header>
                    <mdb-card-body cascade="true">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-12">
                                        <strong>{{vmd.driverPayrollDataFilteredVm.header.driverNumber}} -
                                            {{vmd.driverPayrollDataFilteredVm.header.driverName}}</strong>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <strong>{{vmd.driverPayrollDataFilteredVm.header.driverAddress1}}
                                            {{vmd.driverPayrollDataFilteredVm.header.driverAddress2}}</strong>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <strong>{{vmd.driverPayrollDataFilteredVm.header.driverCity}},
                                            {{vmd.driverPayrollDataFilteredVm.header.driverStateAbbr}}
                                            {{vmd.driverPayrollDataFilteredVm.header.driverPostalCode}}</strong>&nbsp;
                                    </div>
                                </div>
                                <div class="row text-left">&nbsp;</div>
                                <div class="row text-left">&nbsp;</div>
                                <div class="row text-left">&nbsp;</div>
                                <div class="row text-right">
                                    <div class="ml-3 mb-n4">
                                        <mdb-checkbox *ngIf="vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX'"
                                            class="mx-1"
                                            [(ngModel)]="vmd.driverPayrollDataFilteredVm.header.isReviewCompleted"
                                            (change)="onReviewCompletedCheck(vmd)"
                                            [disabled]="vmi.currentPayrollPeriod.payrollPeriodLocked"
                                            data-mdb-tooltip-init title="Payroll Reviewed and Corrected">Payroll Reviewed and Corrected
                                        </mdb-checkbox>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="row text-left" style="color: blue;">
                                    <div class="col-md-6 text-right">Regular:</div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{setRegularAmount(vmd.driverPayrollDataFilteredVm) |
                                            minToTime}}</strong>
                                    </div>
                                </div>
                                <div class="row text-left" style="color: blue;">
                                    <div class="col-md-6 text-right">Overtime:</div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{setOvertimeAmount(vmd.driverPayrollDataFilteredVm) |
                                            minToTime}}</strong>
                                    </div>
                                </div>
                                <div class="row text-left" style="color: blue;"
                                    *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX'">
                                    <div class="col-md-6 text-right">Double time:</div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{setDoubleTimeAmount(vmd.driverPayrollDataFilteredVm) |
                                            minToTime}}</strong>
                                    </div>
                                </div>
                                <div class="row text-left" style="color: blue;"
                                    *ngIf="!vmi.currentPayrollPeriod.includeReportingInCalculation && vmi.currentPayrollPeriod.versionNumber < 5">
                                    <div class="col-md-6 text-right">Reporting:</div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{setReportingAmount(vmd.driverPayrollDataFilteredVm) |
                                            minToTime}}</strong>
                                    </div>
                                </div>
                                <div class="row text-left" style="color: blue;">
                                    <div class="col-md-6 text-right" *ngIf="vmi.currentPayrollPeriod.versionNumber < 5">
                                        Penalty Meal Break Time:
                                    </div>
                                    <div class="col-md-6 text-right"
                                        *ngIf="vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX'">Meal Premium:</div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{setPenaltyMealBreakAmount(vmd.driverPayrollDataFilteredVm) |
                                            minToTime}}</strong>
                                    </div>
                                </div>
                                <div class="row text-left" style="color: blue;"
                                    *ngIf="vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX'">
                                    <div class="col-md-6 text-right">Rest Premium:</div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{setPenaltyRestBreakAmount(vmd.driverPayrollDataFilteredVm) |
                                            minToTime}}</strong>
                                    </div>
                                </div>
                                <hr />
                                <div class="row text-left text-danger">
                                    <div class="col-md-6 text-right">
                                        <a class="text-dark" *ngIf="!vmi.currentPayrollPeriod.payrollPeriodLocked"
                                            (click)="updatePayrollTotalStart(vmd.driverPayrollDataFilteredVm)"><i
                                                class="fas fa-edit"></i></a>&nbsp;
                                        <strong>** PERIOD TOTAL **:</strong>
                                    </div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{setTotalAmount(vmd.driverPayrollDataFilteredVm) |
                                            minToTime}}</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="row text-left" style="color: blue;">
                                    <div class="col-md-6 text-right">Discretionary Gratuity:</div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{setGratuityAmount(vmd.driverPayrollDataFilteredVm) |
                                            currency}}</strong>
                                    </div>
                                </div>
                                <div class="row text-left" style="color: blue;">
                                    <div class="col-md-6 text-right">MiscExpenses:</div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{setMiscExpensesAmount(vmd.driverPayrollDataFilteredVm) |
                                            currency}}</strong>
                                    </div>
                                </div>
                                <div class="row text-left" style="color: blue;"
                                    *ngFor="let a of vmd.driverPayrollDataFilteredVm.header.totalAdjustment.adjustments">
                                    <div class="col-md-6 text-right">{{setAdjustmentsTitle(a)}}:</div>
                                    <div class="col-md-6 text-left">
                                        <strong>{{a.decimalValue | currency}}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div *ngIf="!vmd.driverPayrollDataFilteredVm.adjustmentsCommited"
                                class="row text-left text-danger">
                                <div class="text-right"><strong>Please run payroll calculation to include the
                                        changes in totals</strong></div>
                            </div>
                        </div>

                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
        <!-- Show driver payroll in audit mode -->
        <div class="row" *ngIf="!vmd.workingText && !vmd.errorText && showPayrollInAuditMode">
            <div class="col-md-12 mt-3" *ngFor="let d of vmd.driverPayrollDataFilteredVm.payrollDaysData">
                <div>
                    <mdb-card narrower="true" cascade="true">
                        <app-card-header
                            title="{{d.payrollDate | date: 'MM'}}/{{d.payrollDate | date:'dd'}}/{{d.payrollDate | date: 'yyyy'}}"
                            [headingSize]="6" (actionInvoke)="actionInvoke($event, vmd)"
                            [actions]="d.actions"></app-card-header>
                        <mdb-card-body cascade="true" style="font-weight: bold;">
                            <table responsive="true" class="table table-borderless table-sm">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Confirmation/Description</th>
                                        <th></th>
                                        <th>Duraton</th>
                                        <th>Start</th>
                                        <th>PU Portal</th>
                                        <th>Pickup</th>
                                        <th>DropOff</th>
                                        <th>DO Portal</th>
                                        <th>End</th>
                                        <th>Exp</th>
                                        <th>Grat</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="h6" *ngFor="let a of d.activities">
                                        <ng-container
                                            *ngIf="vmi.currentPayrollPeriod.versionNumber < 5 || (a.recordType != 3 && vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX')">
                                            <!-- do not show 17 is prep time -->
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 3 || a.recordType === 11 || a.recordType === 4">
                                                        {{a.startDateTime | date: 'MM'}}/{{a.startDateTime | date:
                                                        'dd'}}/{{a.startDateTime | date: 'yyyy'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td *ngIf="a.recordType === 13 && a.description !== 'trip-move-to-date'"
                                                class="text-right">
                                                {{getAdjDescription(a.description)}}
                                            </td>
                                            <td colspan="7" *ngIf="a.recordType === 16" class="text-left mt-n4">
                                                <div class="text-center">
                                                    <span class="badge badge-danger" style="font-size: 12px;">*
                                                        {{a.description}}</span>
                                                </div>
                                            </td>
                                            <td *ngIf="a.recordType != 13 && a.recordType != 16">
                                                <ng-container [ngSwitch]="a.recordType">
                                                    <ng-container *ngSwitchCase="3">
                                                        Reporting Time
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="11">
                                                        Start of Shift
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="4">
                                                        End of Shift
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="1">
                                                        <a *ngIf="!vmi.currentPayrollPeriod.payrollPeriodLocked"
                                                            (click)="updateReservationStart(a, d, vmd.driverPayrollDataFilteredVm)"><i
                                                                class="fas fa-edit"></i></a>
                                                        <span data-mdb-tooltip-init
                                                            [attr.title]="a.isReadyForBilling ? 'Priced' : 'Not Priced'"
                                                            [ngStyle]="{ color: a.isReadyForBilling || vmi.currentPayrollPeriod.versionNumber < 5 ? 'inherit' : 'red' }">{{a.confirmationNumber}}</span>
                                                        {{a.description}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="2">
                                                        <a *ngIf="!vmi.currentPayrollPeriod.payrollPeriodLocked"
                                                            (click)="updateReservationStart(a, d, vmd.driverPayrollDataFilteredVm)"><i
                                                                class="fas fa-edit"></i></a>
                                                        <span data-mdb-tooltip-init
                                                            [attr.title]="a.isReadyForBilling ? 'Priced' : 'Not Priced'"
                                                            [ngStyle]="{ color: a.isReadyForBilling || vmi.currentPayrollPeriod.versionNumber < 5 ? 'inherit' : 'red' }">{{a.confirmationNumber}}</span>
                                                        {{a.description}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>
                                                        <span data-mdb-tooltip-init
                                                            [attr.title]="a.isReadyForBilling ? 'Priced' : 'Not Priced'"
                                                            [ngStyle]="{ color: a.isReadyForBilling || vmi.currentPayrollPeriod.versionNumber < 5 ? 'inherit' : 'red' }">{{a.confirmationNumber}}</span>
                                                        {{a.description}}
                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 11 || a.recordType === 4 || a.recordType === 5 || a.recordType === 6 || a.recordType === 14 || a.recordType === 15 || a.recordType === 3">
                                                        {{a.startDateTime | date: 'HH'}}:{{a.startDateTime | date:
                                                        'mm'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2 || a.recordType === 9">
                                                        {{a.tripDurationMinutes | minToTime}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td
                                                [ngClass]="isDateTimeAreTheSame(a.startDateTime, a.origStartDateTime) ? 'CellWithComment' : 'CellWithCommentRed'">
                                                <span class="CellComment">{{a.origStartDateTime | date:
                                                    'HH'}}:{{a.origStartDateTime | date: 'mm'}}</span>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2 || a.recordType === 18">
                                                        {{a.startDateTime | date: 'HH'}}:{{a.startDateTime | date:
                                                        'mm'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td
                                                [ngClass]="isMinutesTimeAreTheSame(a.startPortalMinutes, a.origPickupPortalMinutes) ? 'CellWithCommentBlue' : 'CellWithCommentRed'">
                                                <span class="CellComment">{{a.origPickupPortalMinutes |
                                                    minToTime}}</span>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2">
                                                        {{a.startPortalMinutes |
                                                        minToTime}}{{IsCalculated(a.calculatedPickupGarageMinutes,
                                                        a.startPortalMinutes, a.origPickupPortalMinutes)}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td style="font-weight: bold; color:blue;">
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2">
                                                        {{a.actualStartDateTime | date:
                                                        'MM'}}/{{a.actualStartDateTime | date:
                                                        'dd'}}/{{a.actualStartDateTime | date: 'yyyy'}}
                                                        {{a.actualStartDateTime | date:
                                                        'HH'}}:{{a.actualStartDateTime | date:
                                                        'mm'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td style="font-weight: bold; color:blue;">
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2">
                                                        {{a.actualEndDateTime | date: 'MM'}}/{{a.actualEndDateTime |
                                                        date:
                                                        'dd'}}/{{a.actualStartDateTime | date: 'yyyy'}}
                                                        {{a.actualEndDateTime | date: 'HH'}}:{{a.actualEndDateTime |
                                                        date:
                                                        'mm'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td
                                                [ngClass]="isMinutesTimeAreTheSame(a.endPortalMinutes, a.origDropOffPortalMinutes) ? 'CellWithCommentBlue' : 'CellWithCommentRed'">
                                                <span class="CellComment">{{a.origDropOffPortalMinutes |
                                                    minToTime}}</span>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2">
                                                        {{a.endPortalMinutes |
                                                        minToTime}}{{IsCalculated(a.calculatedDropOffGarageMinutes,
                                                        a.endPortalMinutes, a.origDropOffPortalMinutes)}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td
                                                [ngClass]="isDateTimeAreTheSame(a.endDateTime, a.origEndDateTime) ? 'CellWithComment' : 'CellWithCommentRed'">
                                                <span class="CellComment">{{a.origEndDateTime | date:
                                                    'HH'}}:{{a.origEndDateTime | date: 'mm'}}</span>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2 || a.recordType === 18">
                                                        {{a.endDateTime | date: 'HH'}}:{{a.endDateTime | date:
                                                        'mm'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || (a.recordType === 13 && a.miscExpenses > 0) || a.recordType === 2">
                                                        {{a.miscExpenses | currency}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2 || (a.recordType === 13 && a.gratuity > 0)">
                                                        {{a.gratuity | currency}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                        </ng-container>
                                    </tr>
                                    <tr *ngIf="d.totals.unengagedMinutes > 0">
                                        <td></td>
                                        <td>Unengaged:</td>
                                        <td></td>
                                        <td>{{d.totals.unengagedMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.penaltyBreakMinutes > 0">
                                        <td></td>
                                        <td> 
                                            {{ vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX' ? 'Meal Premium:' : 'Penalty meal break time:' }}
                                        </td>
                                        <td>{{d.totals.penaltyBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.restPenaltyBreakMinutes > 0 && vmi.currentPayrollPeriod.versionNumber >= 5">
                                        <td></td>
                                        <td>Rest Premium:</td>
                                        <td>{{d.totals.restPenaltyBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.unpaidBreakMinutes > 0">
                                        <td></td>
                                        <td>Meal break time (-):</td>
                                        <td>{{d.totals.unpaidBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr *ngFor="let adj of filteradjustments(d.dayAdjustment.adjustments)">
                                        <td></td>
                                        <td>{{setAdjustmentsTitle(adj)}}:</td>
                                        <td></td>
                                        <td>{{setAdjustmentsMinutes(adj)}}</td>
                                        <td></td>
                                        <td></td>
                                        <td>{{setAdjustmentsAmount(adj)}}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="row-top01">
                                        <td></td>
                                        <td class="text-right">Regular:</td>
                                        <td></td>
                                        <td>{{d.totals.regularMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.reportingMinutes > 0 && !vmi.currentPayrollPeriod.includeReportingInCalculation && vmi.currentPayrollPeriod.versionNumber < 5">
                                        <td></td>
                                        <td class="text-right">Reporting:</td>
                                        <td></td>
                                        <td>{{d.totals.reportingMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.penaltyBreakMinutes > 0">
                                        <td></td>
                                        <td class="text-right">
                                            {{ vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX' ? 'Meal Premium:' : 'Penalty Meal Break Time:' }}
                                        </td>
                                        <td></td>
                                        <td>{{d.totals.penaltyBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.restPenaltyBreakMinutes > 0 && vmi.currentPayrollPeriod.versionNumber >= 5">
                                        <td></td>
                                        <td class="text-right">Rest Premium:</td>
                                        <td></td>
                                        <td>{{d.totals.restPenaltyBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td class="text-right">Overtime:</td>
                                        <td></td>
                                        <td>{{d.totals.overtimeMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX'">
                                        <td></td>
                                        <td class="text-right">Double time:</td>
                                        <td></td>
                                        <td>{{d.totals.doubleTimeMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>

                                    <tr class="row-top1">
                                        <td></td>
                                        <td class="text-right">
                                            <a *ngIf="!vmi.currentPayrollPeriod.payrollPeriodLocked"
                                                (click)="updatePayrollDayStart(d, vmd.driverPayrollDataFilteredVm.header.driverNumber, vmd.driverPayrollDataFilteredVm.header.payrollPeriodDriverId)"><i
                                                    class="fas fa-edit"></i></a>
                                            DAY SUB TOTAL:
                                        </td>
                                        <td></td>
                                        <td>{{d.totals.totalDayMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td>{{d.totals.miscExpenses | currency}}</td>
                                        <td>{{d.totals.gratuity | currency}}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
        <!-- Show driver payroll in regular mode -->
        <div class="row" *ngIf="!vmd.workingText && !vmd.errorText && !showPayrollInAuditMode">
            <div class="col-md-6 mt-3" *ngFor="let d of vmd.driverPayrollDataFilteredVm.payrollDaysData">
                <div>
                    <mdb-card narrower="true" cascade="true">
                        <app-card-header
                            title="{{d.payrollDate | date: 'MM'}}/{{d.payrollDate | date:'dd'}}/{{d.payrollDate | date: 'yyyy'}}"
                            [headingSize]="6" (actionInvoke)="actionInvoke($event, vmd)" [actions]="d.actions"
                            [icons]="d.listIcons"></app-card-header>

                        <div class="container" *ngIf="showIssueList(d) && vmi.currentPayrollPeriod.payrollLocation == 'LAX' && vmi.currentPayrollPeriod.versionNumber >= 5">
                            <div class="note note-danger" data-mdb-tooltip-init
                                title="Issue Preventing Chauffeur from Signing Timesheet!">
                                <small>
                                    <strong>Issue Preventing Chauffeur from Signing Timesheet:</strong>
                                    {{buildIssueList(d)}}
                                </small>
                            </div>
                        </div>
                        <div class="container"
                            *ngIf="showNotesFromChauffeur(d.timesheetDetails) && vmi.currentPayrollPeriod.payrollLocation == 'LAX' && vmi.currentPayrollPeriod.versionNumber >= 5">
                            <div class="note note-info" data-mdb-tooltip-init
                                title="Issue Preventing Chauffeur from Signing Timesheet!">
                                <small>
                                    <strong>Notes From Chauffeur:</strong>
                                    {{buildNotesFromChauffeur(d.timesheetDetails.driverBreakDay)}}
                                </small>
                            </div>
                        </div>
                        <mdb-card-body cascade="true" style="font-weight: bold;">

                            <table responsive="true" class="table table-borderless table-sm">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Confirmation/Description</th>
                                        <th></th>
                                        <th>Duraton</th>
                                        <th>Start</th>
                                        <th>End</th>
                                        <th>Exp</th>
                                        <th>Grat</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="h6" *ngFor="let a of d.activities">
                                        <ng-container
                                            *ngIf="vmi.currentPayrollPeriod.versionNumber < 5 || (a.recordType != 3 && vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX')">
                                            <!-- do not show 17 is prep time -->
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 3 || a.recordType === 11 || a.recordType === 4">
                                                        {{a.startDateTime | date: 'MM'}}/{{a.startDateTime | date:
                                                        'dd'}}/{{a.startDateTime | date: 'yyyy'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td *ngIf="a.recordType === 13 && a.description !== 'trip-move-to-date'"
                                                class="text-right">
                                                {{getAdjDescription(a.description)}}
                                            </td>
                                            <td colspan="7" *ngIf="a.recordType === 16" class="text-left mt-n4">
                                                <div class="text-center">
                                                    <span class="badge badge-danger" style="font-size: 12px;">*
                                                        {{a.description}}</span>
                                                </div>
                                            </td>
                                            <td *ngIf="a.recordType != 13 && a.recordType != 16">
                                                <ng-container [ngSwitch]="a.recordType">
                                                    <ng-container *ngSwitchCase="3">
                                                        Reporting Time
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="11">
                                                        Start of Shift
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="4">
                                                        End of Shift
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="1">
                                                        <a *ngIf="!vmi.currentPayrollPeriod.payrollPeriodLocked"
                                                            (click)="updateReservationStart(a, d, vmd.driverPayrollDataFilteredVm)"><i
                                                                class="fas fa-edit"></i></a>
                                                        <span data-mdb-tooltip-init
                                                            [attr.title]="a.isReadyForBilling ? 'Priced' : 'Not Priced'"
                                                            [ngStyle]="{ color: a.isReadyForBilling || vmi.currentPayrollPeriod.versionNumber < 5? 'inherit' : 'red' }">{{a.confirmationNumber}}</span>
                                                        {{a.description}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="2">
                                                        <a *ngIf="!vmi.currentPayrollPeriod.payrollPeriodLocked"
                                                            (click)="updateReservationStart(a, d, vmd.driverPayrollDataFilteredVm)"><i
                                                                class="fas fa-edit"></i></a>
                                                        <span data-mdb-tooltip-init
                                                            [attr.title]="a.isReadyForBilling ? 'Priced' : 'Not Priced'"
                                                            [ngStyle]="{ color: a.isReadyForBilling || vmi.currentPayrollPeriod.versionNumber < 5? 'inherit' : 'red' }">{{a.confirmationNumber}}</span>
                                                        {{a.description}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>
                                                        <span data-mdb-tooltip-init
                                                            [attr.title]="a.isReadyForBilling ? 'Priced' : 'Not Priced'"
                                                            [ngStyle]="{ color: a.isReadyForBilling || vmi.currentPayrollPeriod.versionNumber < 5? 'inherit' : 'red' }">{{a.confirmationNumber}}</span>
                                                        {{a.description}}
                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 11 || a.recordType === 4 || a.recordType === 5 || a.recordType === 6 || a.recordType === 14 || a.recordType === 15 || a.recordType === 3">
                                                        {{a.startDateTime | date: 'HH'}}:{{a.startDateTime | date:
                                                        'mm'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2 || a.recordType === 9">
                                                        {{a.tripDurationMinutes | minToTime}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2 || a.recordType === 18">
                                                        {{a.startDateTime | date: 'HH'}}:{{a.startDateTime | date:
                                                        'mm'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2 || a.recordType === 18">
                                                        {{a.endDateTime | date: 'HH'}}:{{a.endDateTime | date:
                                                        'mm'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || (a.recordType === 13 && a.miscExpenses > 0) || a.recordType === 2">
                                                        {{a.miscExpenses | currency}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                            <td>
                                                <ng-container [ngSwitch]="true">
                                                    <ng-container
                                                        *ngSwitchCase="a.recordType === 1 || a.recordType === 2 || (a.recordType === 13 && a.gratuity > 0)">
                                                        {{a.gratuity | currency}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>

                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                        </ng-container>
                                    </tr>
                                    <tr
                                        *ngIf="d.totals.unengagedMinutes > 0 && (vmd.driverPayrollDataFilteredVm.payrollLocation != 'LAX' || (vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && vmi.currentPayrollPeriod.versionNumber < 5))">
                                        <td></td>
                                        <td>Unengaged:</td>
                                        <td></td>
                                        <td>{{d.totals.unengagedMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.penaltyBreakMinutes > 0">
                                        <td></td>
                                        <td>
                                            {{ vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX' ? 'Meal Premium:' : 'Penalty meal break time:' }}
                                        </td>
                                        <td>{{d.totals.penaltyBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.restPenaltyBreakMinutes > 0 && vmi.currentPayrollPeriod.versionNumber >= 5">
                                        <td></td>
                                        <td>Rest Premium:</td>
                                        <td>{{d.totals.restPenaltyBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.unpaidBreakMinutes > 0">
                                        <td></td>
                                        <td>Meal break time (-):</td>
                                        <td>{{d.totals.unpaidBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr *ngFor="let adj of filteradjustments(d.dayAdjustment.adjustments)">
                                        <td></td>
                                        <td>{{setAdjustmentsTitle(adj)}}:</td>
                                        <td></td>
                                        <td>{{setAdjustmentsMinutes(adj)}}</td>
                                        <td></td>
                                        <td></td>
                                        <td>{{setAdjustmentsAmount(adj)}}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="row-top01">
                                        <td></td>
                                        <td class="text-right">Regular:</td>
                                        <td></td>
                                        <td>{{d.totals.regularMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.reportingMinutes > 0 && !vmi.currentPayrollPeriod.includeReportingInCalculation && vmi.currentPayrollPeriod.versionNumber < 5">
                                        <td></td>
                                        <td class="text-right">Reporting:</td>
                                        <td></td>
                                        <td>{{d.totals.reportingMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.penaltyBreakMinutes > 0">
                                        <td></td>
                                        <td class="text-right">
                                            {{ vmi.currentPayrollPeriod.versionNumber >= 5 && vmi.currentPayrollPeriod.payrollLocation == 'LAX' ? 'Meal Premium:' : 'Penalty meal break time:' }}
                                        </td>
                                        <td></td>
                                        <td>{{d.totals.penaltyBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX' && d.totals.restPenaltyBreakMinutes > 0 && vmi.currentPayrollPeriod.versionNumber >= 5">
                                        <td></td>
                                        <td class="text-right">Rest Premium:</td>
                                        <td></td>
                                        <td>{{d.totals.restPenaltyBreakMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td class="text-right">Overtime:</td>
                                        <td></td>
                                        <td>{{d.totals.overtimeMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr *ngIf="vmd.driverPayrollDataFilteredVm.payrollLocation == 'LAX'">
                                        <td></td>
                                        <td class="text-right">Double time:</td>
                                        <td></td>
                                        <td>{{d.totals.doubleTimeMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>

                                    <tr class="row-top1">
                                        <td></td>
                                        <td class="text-right">
                                            <a *ngIf="!vmi.currentPayrollPeriod.payrollPeriodLocked"
                                                (click)="updatePayrollDayStart(d, vmd.driverPayrollDataFilteredVm.header.driverNumber, vmd.driverPayrollDataFilteredVm.header.payrollPeriodDriverId)"><i
                                                    class="fas fa-edit"></i></a>
                                            DAY SUB TOTAL:
                                        </td>
                                        <td></td>
                                        <td>{{d.totals.totalDayMinutes | minToTime}}</td>
                                        <td></td>
                                        <td></td>
                                        <td>{{d.totals.miscExpenses | currency}}</td>
                                        <td>{{d.totals.gratuity | currency}}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>
</div>